import React, { useMemo, useState } from "react";
import { useOutletContext, useSearchParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";

import SinglePage1 from "../SinglePage1";
import NavbarScroll from "../../components/subComponents/NavbarScroll";
import { useItemCategoryInfinite } from "../../hooks/useItemCategoryInfinite";
import PollsCard from "../../components/subComponents/PollsCard";
import { saffronURL } from "../../Url";

const safeArray = (v) => (Array.isArray(v) ? v : []);

const addPosition = (arr) =>
  safeArray(arr).map((item, i) => ({ ...item, position: i }));

const Poll = () => {
  const {
    selectedCountry,
    selectedCategory,
    selectedLanguage,
    selectedState,
    selectedCity,
  } = useOutletContext();

  const [searchParams, setSearchParams] = useSearchParams();

  // ✅ navbar se aane wala category_name (code)
  const categoryName = searchParams.get("category_name") || "";



  const {
    item: polls,
    ref,
    hasNextPage,
    isFetchingNextPage,
    isPending: pollsPending,
  } = useItemCategoryInfinite({
    key: "connect_Poll",
    endpoint: "polls",
    listKey: 'polls',
    category_name: categoryName,
    selectedCategory,
    selectedCountry,
    selectedLanguage,
    selectedState,
    selectedCity,
    enabled: true,
    threshold: 0.7,
  });

  const hasPolls = polls?.length > 0;

  // Menu data
  const { data: menuData ,isLoading: loadingTree  } = useQuery({
    queryKey: [
      "menuData_connect_slide",
      selectedCountry,
      selectedLanguage,
      selectedCategory,
      selectedState,
      selectedCity,
    ],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (selectedCountry) params.append("country", selectedCountry);
      if (selectedLanguage) params.append("language", selectedLanguage);
      if (selectedCategory) params.append("category", selectedCategory);
      if (selectedState) params.append("state", selectedState);
      if (selectedCity) params.append("city", selectedCity);

      const url = `${saffronURL}/api/v1/public/menu?${params.toString()}`;
      const resp = await axios.get(url);
      return resp.data;
    },
    enabled: !!(selectedCountry || selectedLanguage || selectedCategory),
    retry: 2,
    staleTime: 1000 * 60 * 10,
    cacheTime: 1000 * 60 * 60,
    refetchOnWindowFocus: false,
  });

  const navbaritems = useMemo(() => {
    return menuData?.data?.items?.find((item) => item.key === "poll");
  }, [menuData]);

  const getPolls = useMemo(() => addPosition(polls), [polls]);


  

 



  const handleCategorySelect = (child) => {
    const params = new URLSearchParams(searchParams);

    // child.code ko URL me save karo
    if (child?.code) params.set("category_name", child.code);
    else params.delete("category_name");


    setSearchParams(params, { replace: false });
  };

  // ✅ List view
  return (
    <>
      <NavbarScroll
        items={navbaritems}
        activeCode={categoryName} // ✅ highlight
        onSelect={handleCategorySelect} // ✅ set URL + triggers refetch
        loading={loadingTree}

      />



      <section className="py-3 px-1 md:px-5 lg:px-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          <PollsCard getPolls={getPolls}/>
        </div>

        {/* Status */}
        {pollsPending && (
          <p className="text-gray-500 text-center mt-6">
            Loading polls...
          </p>
        )}

        {!pollsPending && !hasPolls && (
          <p className="text-gray-400 text-center mt-6">
            No polls found in <span className="font-medium">'Polls'</span>
          </p>
        )}

        {hasNextPage && <div ref={ref} className="h-10" />}

        {isFetchingNextPage && (
          <div className="text-center text-sm text-gray-500 py-4">
            Loading more...
          </div>
        )}
      </section>

    </>
  );
};

export default Poll;